import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';

/**
 * ReEvaluateActionPath
 *
 * Re-trigger the activation of the action path and will go and find records that meet the entrance criteria that are
 * not currently on the Action Path.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const ReEvaluateActionPath = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theMutationKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      data: {},
      headers: {
        'x-api-endpoint': `/action-paths/re-evaluate/${thePayload?.actionPathId}`,
      },
      method: 'PUT',
      params: { apiKey: theApiKey, mutationKey: theMutationKey },
    };

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error(
      'src/entities/ActionPath/api/requests/mutations/ReEvaluateActionPath.js -> ReEvaluateActionPath()',
      false,
      error
    );

    throw error;
  }
};
